import { render, staticRenderFns } from "./ContractOverviewTab.vue?vue&type=template&id=5f4aa372&"
import script from "./ContractOverviewTab.vue?vue&type=script&lang=js&"
export * from "./ContractOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports